// Centralised WhatsApp config — update phone number here in a single place.
export const WHATSAPP_PHONE = "33662745046"; // +33 6 62 74 50 46 — international, no '+' or spaces
export const WHATSAPP_DEFAULT_MESSAGE =
  "Bonjour, je souhaite réserver un diagnostic gratuit ShinRai de 45 min.";

export function whatsappUrl(message = WHATSAPP_DEFAULT_MESSAGE) {
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
}
